import formatNumber from '@/utils/NumberFormatter';

import UnitDimension, { IUnitDimensionAPI } from './UnitDimension';

export interface IUnitRatioStatusAPI {
  ratio: number[];
  status: string;
  unit_dimension_statuses: IUnitDimensionAPI[];
}

export default class UnitRatioStatus {
  ratio: number[];

  status: string;

  unitDimensionStatuses: UnitDimension[];

  constructor(ratio: number[], status: string, unitDimensionStatuses: UnitDimension[]) {
    this.ratio = ratio;
    this.status = status;
    this.unitDimensionStatuses = unitDimensionStatuses;
  }

  get unitCount(): number {
    return this.unitDimensionStatuses.reduce((mem, x) => mem + x.unitIDs.length, 0);
  }

  get unitCoveredCount(): number {
    return this.unitDimensionStatuses.filter((x) => x.status !== 'BAD').reduce((mem, x) => mem + x.unitIDs.length, 0);
  }

  get unitCountFormatted(): string {
    return formatNumber(this.unitCount, '0,0');
  }

  get ratioFormatted(): string {
    return `${this.ratio[0]} x ${this.ratio[1]}`;
  }

  get unitDimension(): UnitDimension {
    return new UnitDimension(this.ratio[0], this.ratio[1], this.status);
  }

  static fromApi(apiObject: IUnitRatioStatusAPI): UnitRatioStatus {
    return new UnitRatioStatus(
      apiObject.ratio,
      apiObject.status,
      apiObject.unit_dimension_statuses != null
        ? apiObject.unit_dimension_statuses.map((x: IUnitDimensionAPI) => UnitDimension.fromApi(x))
        : [],
    );
  }

  toApi(): IUnitRatioStatusAPI {
    return {
      ratio: this.ratio,
      status: this.status,
      unit_dimension_statuses: this.unitDimensionStatuses?.map((x) => x.toApi()),
    };
  }
}
